import { useMutation } from '@northladder/services';

import { ASSET_TRACKER_SERVICE_API } from '../assetTrackerClient';
import { IValidateLoginTypeData } from '../types';

/**
 * Cache key for the login validation mutation.
 * This is used to identify the mutation in the cache.
 */
export const LOGIN_VALIDATE_TYPE_MUTATION_KEY =
  'login-validate-type-mutation-key';

interface IUseValidateLoginTypeMutation {
  onSuccessCallback: (data: IValidateLoginTypeData) => void;
  onErrorCallback?: () => void;
}

/**
 * This performs an API call to validate the login type for the user.
 * It is used to determine the authentication type for the user based on their
 * email address.
 */
export function useValidateLoginTypeMutation({
  onSuccessCallback,
  onErrorCallback,
}: Readonly<IUseValidateLoginTypeMutation>) {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [LOGIN_VALIDATE_TYPE_MUTATION_KEY],
    mutationFn: ASSET_TRACKER_SERVICE_API.validateLoginType,
    onError: onErrorCallback,
    onSuccess: onSuccessCallback,
  });

  return {
    error,
    isPending,
    validateLoginType: mutate,
  };
}
